<template>
  <div>
    <div class="text-muted small">{{activity.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->
    <UserLink :user="activity.causer" />

    <!--ACTIVITY LOG ACTION-->
    {{ $t('actions.' + $options.filters.slugify(activity.description)) }}

    <!--CREATED-->
    <div v-if="activity.description === 'added'">
      <div v-if="activity.subject">
        <span> {{ $t('systems.policies.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.policy.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                     :to="{ name: 'systems.view', params: { slug: activity.subject.system.slug }}"
        >
              {{activity.properties.system.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('systems.policies.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.policy.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.properties.system.slug }}"
        >
              {{activity.properties.system.name}}
        </router-link>
      </div>
    </div>

    <!--DELETED-->
    <div v-if="activity.description === 'removed'">
      <div v-if="activity.subject">
        <span> {{ $t('systems.policies.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.policy.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.subject.system.slug }}"
        >
              {{activity.properties.system.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('systems.policies.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.policy.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
                :to="{ name: 'systems.view', params: { slug: activity.properties.system.slug }}"
        >
              {{activity.properties.system.name}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import UserLink from '@/components/user/Link.vue';

export default {
  name: 'SystemPolicy',
  data: function() {
    return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
    }
  },
  props: {
      activity: {},
        changes: false
  },
  components:{
      UserLink
  },
  computed: {
      getNavType() {
            return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
  },
      watch: {
      },
  methods: {
    loadContent(page) {
    }
  },
    created () {
    }
}
</script>

<style scoped lang="scss">

</style>
